import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuex from 'vuex';

/**全部加载 */
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import { VueAxios } from './utils/request';

import '@/css/main.scss';
import axios from 'axios';
import { apis, http } from '@/apis/apis.js';
import createStore from '@/store/store.js';

import moment from 'moment';
import 'moment/locale/zh-cn';
import storage from 'store';

moment.locale('zh-cn');

/**按需注册组件 */
//import { Button } from 'ant-design-vue';

//Vue.component(Button.name, Button);

import vLoad from '@/components/load.js';

Vue.use(Vuex);
Vue.use(Antd);
Vue.use(vLoad);
Vue.use(VueAxios);

Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.prototype.$axios = axios;
Vue.prototype.$apis = apis;
Vue.prototype.moment = moment;

import pageHeader from '@/components/pageHeader/index.pageHeader.vue';
import pageTopbar from '@/components/pageTopbar/index.pageTopbar.vue';
Vue.component(pageHeader.name, pageHeader);
Vue.component(pageTopbar.name, pageTopbar);

// 阻止启动生产消息
Vue.config.productionTip = false;

Vue.prototype.initPages = () => {
  return {
    total: 0,
    size: 'Pagination',
    defaultCurrent: 1,
    defaultPageSize: 10,
    current: 1,
    pageSize: 10,
    showQuickJumper: true,
    size: 'small',
    showTotal: function(total, range) {
      return '当前从' + range[0] + '至' + range[1] + ',共' + total + '条记录';
    },
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200', '500']
  };
};
// router 拦截器
router.beforeEach((to, from, next) => {
  let { access_token, expire } = to.query;
  if (access_token && expire) {
    storage.set('access_token', access_token);
    storage.set('expire', expire);
  } else {
    access_token = storage.get('access_token');
    expire = storage.get('expire');
  }
  // 让每个请求携带自定义 access_token 请根据实际情况自行修改
  var t = new Date().getTime();
  if (to.path == '/login' || (access_token && expire && expire > t)) {
    return next();
  } else {
    next('login');
  }
  //window.location.href = '/#/login';
});

var app = new Vue({
  router,
  store: createStore(Vue.prototype),
  render: (h) => h(App)
}).$mount('#app');

Vue.prototype.$http = http.bind(app);
app.$store.$http = Vue.prototype.$http;
